import { useEffect, useRef, useState } from 'react';

import { IUseRemainingTimeParams, IUseRemainingTimeReturn } from './useRemainingTime.type';
import { calcRefreshTime, getRefreshDateValue, setRefreshDateValue } from './useRemainingTime.utils';

/**
 * @description хук для вычисления оставшегося времени
 * @param params
 * @param params.key - по этому ключу сохраняется значение времени от которого ведется исчисление
 * @param params.save - место куда сохраняется значение времени
 * @param params.delay - время задержки, т.е. то время которое будет отсчитываться до конца
 */
const useRemainingTime = (params: IUseRemainingTimeParams): IUseRemainingTimeReturn => {
    const { key, save = 'session', delay } = params;
    // устанавливаем время
    const [time, setTime] = useState<string | undefined>(calcRefreshTime(getRefreshDateValue(save, key), delay));
    const timerRef = useRef<NodeJS.Timeout | null>(null);

    /**
     * @description обновляем время отсчета и устанавливаем оставшиеся время
     */
    const setTimer = () => {
        const refreshDate = setRefreshDateValue(save, key);
        setTime(calcRefreshTime(refreshDate, delay));
    };

    /**
     * @description обновляем значение оставшегося времени каждую секунда
     */
    useEffect(() => {
        if (key) {
            timerRef.current = setInterval(() => {
                const refreshDate = getRefreshDateValue(save, key);
                setTime(calcRefreshTime(refreshDate, delay));
            }, 1000);
        }

        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
            }
        };
    }, [key, delay]);

    return { time, setTimer };
};

export default useRemainingTime;
